import { Controller } from '@hotwired/stimulus';

// The sidebar edge's hint: it waits until the pointer rests on the line for
// a moment, then opens beside the pointer, where it stopped. Moving before
// that restarts the wait; leaving or pressing closes it.
export default class extends Controller {
  static targets = ['tip'];
  static values = { delay: { type: Number, default: 1000 } };

  disconnect() {
    this.hide();
  }

  rest(event) {
    if (this.tipTarget.classList.contains('show')) return;

    clearTimeout(this.timer);
    this.y = event.clientY;
    this.timer = setTimeout(() => this.show(), this.delayValue);
  }

  show() {
    const edge = this.element.getBoundingClientRect();
    const tip = this.tipTarget.getBoundingClientRect();
    const top = this.y - edge.top - tip.height / 2;
    const max = edge.height - tip.height - 8;

    this.tipTarget.style.top = `${Math.max(8, Math.min(top, max))}px`;
    this.tipTarget.classList.add('show');
  }

  hide() {
    clearTimeout(this.timer);
    this.tipTarget.classList.remove('show');
  }
}
